import React from "react";
import myWarhammerLogo from "../../assets/warhammer-logo-black.png";

const Logo: React.FC = () => {
  return (
    <img
      height="95"
      width="95"
      src={myWarhammerLogo}
      alt=""
      data-testid="logo"
    />
  );
};

export default Logo;
